import styles from './PatternBackground.module.css';

/**
 * Фоновый каллиграфический орнамент.
 *
 * ВАЖНО, и это не стилистическое решение: используются ТОЛЬКО
 * изолированные буквы алфавита. В арабском письме буквы внутри слова
 * соединяются между собой, поэтому несоединённые глифы физически
 * не могут прочитаться как слово. Это гарантирует, что фон остаётся
 * орнаментом и не превращается в случайный — и потому неуместный —
 * текст под ногами у пользователя.
 *
 * Не заменять на связную вязь и не копировать реальные аяты:
 * священный текст в роли декорации, по которому скроллят, — ровно
 * то, чего здесь быть не должно.
 */

/** Изолированные формы, выбранные за характерный рисунок */
const LETTERS = [
  'ه', 'م', 'ع', 'ن', 'ص', 'ل', 'ك', 'ح',
  'ط', 'س', 'ر', 'د', 'ب', 'ي', 'ف', 'ق',
  'و', 'ج', 'ش', 'هـ',
];

/**
 * Раскладка задана явно, а не случайной генерацией: узор должен быть
 * одинаковым при каждом рендере, иначе фон «дёргается» между экранами.
 * Значения подобраны так, чтобы плитка стыковалась без видимых швов.
 */
const GLYPHS: { x: number; y: number; size: number; rotate: number; i: number }[] = [
  { x: 22, y: 58, size: 62, rotate: -14, i: 0 },
  { x: 96, y: 30, size: 44, rotate: 22, i: 5 },
  { x: 158, y: 66, size: 74, rotate: -6, i: 2 },
  { x: 232, y: 40, size: 50, rotate: 34, i: 9 },
  { x: 284, y: 78, size: 58, rotate: -20, i: 13 },
  { x: 54, y: 128, size: 52, rotate: 8, i: 7 },
  { x: 124, y: 152, size: 68, rotate: -28, i: 11 },
  { x: 198, y: 130, size: 46, rotate: 16, i: 3 },
  { x: 262, y: 160, size: 60, rotate: -10, i: 16 },
  { x: 18, y: 196, size: 48, rotate: 26, i: 14 },
  { x: 88, y: 226, size: 64, rotate: -18, i: 1 },
  { x: 160, y: 208, size: 42, rotate: 12, i: 18 },
  { x: 226, y: 240, size: 56, rotate: -32, i: 6 },
  { x: 296, y: 214, size: 50, rotate: 18, i: 10 },
  { x: 46, y: 286, size: 58, rotate: -8, i: 4 },
  { x: 132, y: 300, size: 46, rotate: 30, i: 17 },
  { x: 206, y: 284, size: 66, rotate: -24, i: 8 },
  { x: 278, y: 308, size: 44, rotate: 10, i: 12 },
];

const TILE = 340;

export function PatternBackground() {
  return (
    <svg className={styles.pattern} aria-hidden="true" focusable="false">
      <defs>
        <pattern
          id="sa-calligraphy"
          width={TILE}
          height={TILE}
          patternUnits="userSpaceOnUse"
        >
          {GLYPHS.map((g, n) => (
            <text
              key={n}
              x={g.x}
              y={g.y}
              fontSize={g.size}
              transform={`rotate(${g.rotate} ${g.x} ${g.y})`}
            >
              {LETTERS[g.i]}
            </text>
          ))}
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#sa-calligraphy)" />
    </svg>
  );
}
